<template>
  <div class="d-flex align-items-center py-2 px-3">
    <div class="d-flex justify-content-center mr-4 status-bar-info px-3">
      <span class="d-flex align-items-center">
        <Users class="mr-2" :size="20" />
        <b class="mr-1">Ist PAX:</b>
        {{ formatNumber(istPax) }}
        <span class="ml-3">
          <b class="mr-1">FC Pax:</b>
          {{ formatNumber(fcPax) }}
        </span>
        <span class="ml-3">
          <b class="mr-1">FC Pax Potenzial:</b>
          {{ formatNumber(fcPaxPotenzial) }}
        </span>
      </span>
    </div>

    <div class="d-flex justify-content-center mr-4 status-bar-info px-3">
      <span class="d-flex align-items-center">
        <Coins class="mr-2" :size="20" />
        <b class="mr-1">Ist Umsatz:</b>
        {{ formatCurrency(istUmsatz) }}
        <span class="ml-3">
          <b class="mr-1">FC Umsatz:</b>
          {{ formatCurrency(fcUmsatz) }}
        </span>
        <span class="ml-3">
          <b class="mr-1">FC Umsatz Potenzial:</b>
          {{ formatCurrency(fcUmsatzPotenzial) }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { Users, Coins } from 'lucide-vue';

export default {
  components: { Users, Coins },
  data() {
    return {
      istPax: 0,
      fcPax: 0,
      fcPaxPotenzial: 0,
      istUmsatz: 0,
      fcUmsatz: 0,
      fcUmsatzPotenzial: 0,
    };
  },

  methods: {
    setSums({ istPax, fcPax, fcPaxPotenzial, istUmsatz, fcUmsatz, fcUmsatzPotenzial } = {}) {
      this.istPax = istPax ?? 0;
      this.fcPax = fcPax ?? 0;
      this.fcPaxPotenzial = fcPaxPotenzial ?? 0;
      this.istUmsatz = istUmsatz ?? 0;
      this.fcUmsatz = fcUmsatz ?? 0;
      this.fcUmsatzPotenzial = fcUmsatzPotenzial ?? 0;
    },

    formatNumber(value) {
      if (value == null) return '-';
      return value.toLocaleString('de-DE');
    },

    formatCurrency(value) {
      if (value == null) return '-';
      return this.$options.filters.currency(value);
    },
  },
};
</script>

<style scoped>
.status-bar-info {
  border: 1px solid var(--border);
  background-color: var(--surface);
  height: 38px;
  border-radius: 5px;
}
</style>
